const waterfallChart = (() => {
    /**
     * init : initializing bar group chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param config object
     */
	const init = (config) => {
		let { margin, width, data, neg_y_axis } = config;
		width = width - margin.left - margin.right;
		const height = (config.height)?config.height:200, padding = 0.2;

		const x = d3
			.scaleBand()
			.rangeRound([0, width])
			.padding(padding);

		const y = d3
			.scaleLinear()
			.domain([neg_y_axis ? -1 * d3.max(data, (d) => d.end) : 0, d3.max(data, (d) => d.end)])
			.range([height, 0]);

		const xAxis = d3.axisBottom(x);

		const yAxis = d3
			.axisLeft(y)
			.ticks(3, "f")
			// .tickValues([0, 100000, 1000000])
			.tickPadding(3)
			// .tickFormat((d) => {
			// 	// return initScript.separateNumberByDelimiter(d);
			// 	return initScript.separateNumberByDelimiterWithSignAndThousand(d)
			// });

		const chart = d3
			.select(config.id)
			.append("svg")
			.attr('width', width + margin.left + margin.right)
			.attr('height', height + margin.top + margin.bottom)
			.append('g')
			.attr('transform', `translate(${margin.left}, ${margin.top})`);

		x.domain(data.map((d) => d.name));

		chart
			.append('g')
			.attr('class', 'x axis x_axis_private')
			.attr('transform', `translate(0, ${ config.neg_y_axis ? (height / 2) : height })`)
			.call(xAxis);

		chart
			.append('g')
			.attr('class', 'y axis')
			.call(yAxis);

		const bar = chart.selectAll('.bar')
			// .data(data)
			.data(data.reverse())
			.enter().append('g')
			.attr('class', (d) => {
				return `bar ${d.class}`;
			})
			.attr('transform', (d, i) => {
				return `translate(${x(!!d.parent ? data[d.parent].name : d.name)}, 0)`;
			});

		if (config.neg_y_axis) {
			chart.selectAll('.x_axis_private g line')
				.style("display", "none");

			chart.selectAll('.x_axis_private g text')
			.attr('transform', `translate(0, ${height / 2})`);
		}

		bar
			.append('rect')
			.attr('y', (d) => y(Math.max(d.start, d.end)))
			.attr('height', (d) => Math.abs(y(d.start) - y(d.end)))
			.attr('width', x.bandwidth());

		bar.append("text")
			.attr("x", function (d) {
				return x.bandwidth() / 2
			})
			.attr("y", function (d) {
				if (config.neg_y_axis && d.class !== "est_operating_profit_rect1") {
					if(d.class === "current_debt_rect" && d.value < 0) return height / 2 - 10;
					if(d.class === "current_debt_rect") return height / 2 - 7 //height / 2 + 10;

					// ASTRO
					// if(d.class === "future_debt_rect" && d.value < 0) return height / 2 - 10;
					// if(d.class === "future_debt_rect") return height / 2 + 10;
					// BSA
					if(d.class.split(" ").indexOf("future_debt_rect_negative_values") !== -1) return height / 2 - 10;
					if(d.class.split(" ").indexOf("future_debt_rect_positive_values") !== -1) return height / 2 + 10;
					// ASTRO - enable for variable marking label
					// if(d.class === "margin_future_debt_rect" && d.value < 0) return height / 2 + (initScript.getHTMLElementObject("svg .future_debt_rect rect").height() + initScript.getHTMLElementObject("svg .margin_future_debt_rect rect").height()) + 10;
					// if(d.class === "margin_future_debt_rect") return -10;
					
					// BSA - fixed marking label
					if(d.class === "margin_future_debt_rect" && d.value < 0) return height -10; 
					// else if(d.class === "margin_future_debt_rect") return height / 2 - (initScript.getHTMLElementObject("svg .future_debt_rect rect").height() + initScript.getHTMLElementObject("svg .margin_future_debt_rect rect").height()) - 10;
					if(d.class === "margin_future_debt_rect") return -10;
					
					if(d.class === "margin_current_debt_rect" && d.value < 0) return height - 10;
					// if(d.class === "margin_current_debt_rect") return height / 2 - (initScript.getHTMLElementObject("svg .current_debt_rect rect").height() + initScript.getHTMLElementObject("svg .margin_current_debt_rect rect").height()) - 10;
					if(d.class === "margin_current_debt_rect") return -10;
				}
				return (y(Math.max(d.start, d.end)) - 10);
			})
			.style("fill", "black")
			.style("z-index", "999999")
			.attr("dy", ".35em")
			.html(d => {
				if (d.value === 0) return "";
				return initScript.separateNumberByDelimiterWithSign(d.value).replace(/[kK]/, "");
			})
	};
	return {
		init,
	};
})();
